// extracted by mini-css-extract-plugin
export var anchorContainer = "lcAnchorHeading-module--anchorContainer--785dd";
export var anchorHeading = "lcAnchorHeading-module--anchorHeading--cc202";
export var anchorLink = "lcAnchorHeading-module--anchorLink--6217a";
export var copied = "lcAnchorHeading-module--copied--8f4df";
export var copiedAnchor = "lcAnchorHeading-module--copiedAnchor--6d4f8";
export var headingContent = "lcAnchorHeading-module--headingContent--cbe65";
export var visible = "lcAnchorHeading-module--visible--81da8";